module.exports = __webpack_public_path__ + "static/img/Jesse-Dattoli.ef3eded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-Dattoli.jpg
// module id = 2oZq
// module chunks = 0